export class UtilityConfig{
    static Set_Utility_Config_State = 'Set_Utility_Config_State'
    static Logout = 'Logout'
}